import React, { useEffect } from 'react';
import { FaDiscord } from 'react-icons/fa';
import './ProjetoFinal.css';

const DISCORD_URL = 'https://discord.gg/9W4Vusc4m2';
const DOC_CODE = 'NX-PF-001';

const ProjetoFinal = () => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Nexus: A Última Luz — Confidencial';

    let robots = document.querySelector('meta[name="robots"]');
    const created = !robots;
    if (!robots) {
      robots = document.createElement('meta');
      robots.setAttribute('name', 'robots');
      document.head.appendChild(robots);
    }
    const previousRobots = robots.getAttribute('content');
    robots.setAttribute('content', 'noindex, nofollow, noarchive');

    return () => {
      document.title = previousTitle;
      if (created) {
        robots.remove();
      } else if (previousRobots) {
        robots.setAttribute('content', previousRobots);
      }
    };
  }, []);

  return (
    <main className="pf">
      <div className="pf-desk" aria-hidden="true" />

      <article className="pf-sheet" aria-labelledby="pf-title">
        <div className="pf-classbar">Confidencial · não reproduzir · não publicar</div>

        <div className="pf-holes" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>

        <header className="pf-mast">
          <div>
            <p className="pf-brand">Rede Nexus</p>
            <p className="pf-org">Operada por Vih&apos;s Studio</p>
          </div>
          <dl className="pf-meta">
            <div>
              <dt>Documento</dt>
              <dd>{DOC_CODE}</dd>
            </div>
            <div>
              <dt>Emissão</dt>
              <dd>10 out 2026</dd>
            </div>
            <div>
              <dt>Classificação</dt>
              <dd>Confidencial</dd>
            </div>
            <div>
              <dt>Validade</dt>
              <dd>Até ordem de abertura</dd>
            </div>
          </dl>
        </header>

        <div className="pf-titleblock">
          <div>
            <p className="pf-kicker">Dossiê de convite · distribuição restrita</p>
            <h1 id="pf-title">Nexus: A Última Luz</h1>
            <p className="pf-subject">Servidor para criação de conteúdo de RP Minecraft</p>
          </div>
          <div className="pf-stamp" aria-hidden="true">
            <span>Confidencial</span>
            <small>não publicar</small>
          </div>
        </div>

        <dl className="pf-routing">
          <div>
            <dt>Para</dt>
            <dd>
              Destinatário autorizado. O elenco previsto é, em sua maioria, de criadores
              de conteúdo. Um convidado sem canal pode receber o mesmo exemplar. O sigilo
              vale para os dois.
            </dd>
          </div>
          <div>
            <dt>De</dt>
            <dd>Comando da Rede Nexus · Vih&apos;s Studio</dd>
          </div>
          <div>
            <dt>Assunto</dt>
            <dd>
              Convite a Nexus: A Última Luz, servidor de criação de conteúdo de RP.
              A elite conduz a história com uma premissa: só uma luz permanece.
            </dd>
          </div>
        </dl>

        <section>
          <h2><span>01</span> Finalidade deste exemplar</h2>
          <p>
            Você está recebendo este dossiê porque a Rede Nexus decidiu chamá-lo antes
            do anúncio. O documento apresenta <strong>Nexus: A Última Luz</strong>,
            um servidor feito para criação de conteúdo de RP, e formaliza o convite
            para entrar nesse elenco.
          </p>
          <p>
            Não é um comunicado público. Não circula no menu do site nem em canal aberto.
            Quem não recebeu o link não deve ser informado do conteúdo.
          </p>
        </section>

        <section>
          <h2><span>02</span> O que é o servidor</h2>
          <p>
            Nexus: A Última Luz é, antes de tudo, um servidor para{' '}
            <strong>criação de conteúdo de RP</strong>. O modpack é o meio. A temporada
            é o material. Guerra, aliança, espiões e história existem para virar cena:
            algo vivido no jogo e registrado por quem está dentro dele.
          </p>
          <p>
            Não é um survival aberto nem uma sequência do Nexus Origins. O Origins
            continua em operação, com plugins oficiais e sem modpack. Este é um mundo
            separado e fechado, com começo, conflito e desfecho, montado para ser
            produzido como conteúdo.
          </p>
        </section>

        <section>
          <h2><span>03</span> A premissa</h2>
          <p>
            Os jogadores entram num mundo já ocupado por uma <strong>elite</strong> muito
            acima deles. Essa elite não joga no mesmo chão. Ela conduz o cenário por
            trás: regras, pressão, reviravoltas e o rumo da história.
          </p>
          <p>
            A premissa que essa elite impõe é simples: <strong>apenas uma pessoa sai
            viva</strong>. Uma última luz. O nome do servidor é essa sentença. A
            temporada pode quebrar a regra, e outras histórias podem nascer em volta
            dela, mas o mundo é conduzido como se só uma luz fosse permanecer.
          </p>
          <p>
            Quem está no elenco precisa sobreviver entre si. Cooperar, trair, espionar
            e escolher um lado fazem parte da temporada. A narrativa conduzida por trás
            existe para a gameplay não ser só combate.
          </p>
        </section>

        <section>
          <h2><span>04</span> Regra de vida</h2>
          <p>
            Cada jogador carrega uma vida que pode acabar de vez. A morte comum não
            elimina na hora. Ela abre uma janela curta.
          </p>
          <ol className="pf-rules">
            <li>
              <strong>Queda.</strong> Ao “morrer”, o jogador fica desmaiado por 60 segundos.
            </li>
            <li>
              <strong>Socorro.</strong> Se alguém o socorrer antes de acabar esse tempo,
              ele levanta e segue o jogo. Não perde os itens.
            </li>
            <li>
              <strong>Execução.</strong> Se outro jogador o finalizar dentro desses 60
              segundos, a temporada acaba para ele. Não há retorno ao jogo.
            </li>
            <li>
              <strong>Tempo esgotado.</strong> Se os 60 segundos passarem sem socorro e
              sem execução, ele renasce e perde os itens.
            </li>
          </ol>
          <p>
            A tensão mora nessa janela: socorrer, negociar ou acabar com alguém diante
            de quem está assistindo e gravando.
          </p>
        </section>

        <section>
          <h2><span>05</span> O elenco</h2>
          <p>
            O servidor reúne um grupo escolhido, não uma whitelist aberta. A maior parte
            das vagas é de criadores de conteúdo, porque produzir o RP é a função do
            servidor: a história precisa ser vivida, narrada e registrada por quem joga.
          </p>
          <p>
            Quem não produz conteúdo entra pelo mesmo critério de confiança. Audiência
            não decide a vaga. Discrição, até a ordem de abertura, decide se a pessoa
            permanece.
          </p>
        </section>

        <section>
          <h2><span>06</span> Informações retidas</h2>
          <p>Até autorização da Rede Nexus, permanece fora deste papel e de qualquer publicação:</p>
          <ul className="pf-held">
            <li><span>Data e hora de abertura</span> <Redacted /></li>
            <li><span>Lista e versão do modpack</span> <Redacted /></li>
            <li><span>Endereço de conexão</span> <Redacted /></li>
            <li><span>Elenco confirmado</span> <Redacted /></li>
            <li><span>Imagens, prints ou gravações do mundo</span> <Redacted /></li>
          </ul>
        </section>

        <section>
          <h2><span>07</span> Conduta exigida</h2>
          <ol>
            <li>Não encaminhar este dossiê.</li>
            <li>Não publicar, insinuar data ou confirmar o projeto em público.</li>
            <li>Não usar live, story ou grupo aberto como canal de anúncio.</li>
            <li>Levar dúvidas ao canal da seção 08, não a conversas soltas.</li>
          </ol>
          <p className="pf-warning">
            O descumprimento encerra o convite e a vaga no elenco.
          </p>
        </section>

        <section className="pf-reply">
          <h2><span>08</span> Como responder</h2>
          <p>
            Para aceitar, recusar ou pedir esclarecimento, fale com a equipe no Discord
            oficial e cite o código do documento.
          </p>
          <p className="pf-code">
            Código de referência <strong>{DOC_CODE}</strong>
          </p>
          <a className="pf-discord" href={DISCORD_URL} target="_blank" rel="noopener noreferrer">
            <FaDiscord aria-hidden="true" />
            Discord da Rede Nexus
          </a>
          <p className="pf-note">A resposta por esse canal é o registro do convite.</p>
        </section>

        <section>
          <h2><span>09</span> Encerramento</h2>
          <p>
            A Rede Nexus agradece a discrição. Quando A Última Luz puder ser dita em
            voz alta, quem guardou este documento será avisado antes do público.
          </p>
        </section>

        <footer className="pf-sign">
          <div>
            <p className="pf-sign__role">Comando da Rede Nexus</p>
            <p>Vih&apos;s Studio</p>
            <p>A Última Luz · exemplar {DOC_CODE}</p>
          </div>
          <p className="pf-sign__mark">Assinado para circulação restrita</p>
        </footer>

        <div className="pf-classbar pf-classbar--end">
          Confidencial · posse não autoriza reprodução · NX-PF-001
        </div>
      </article>
    </main>
  );
};

function Redacted() {
  return (
    <span className="pf-redact" aria-label="Informação retida até autorização">
      retido
    </span>
  );
}

export default ProjetoFinal;
